import { render, staticRenderFns } from "./IncDec.vue?vue&type=template&id=3b267a44&"
import script from "./IncDec.vue?vue&type=script&lang=js&"
export * from "./IncDec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports